import { render, staticRenderFns } from "./SliderTanimla.vue?vue&type=template&id=2bcc4aee&scoped=true&"
import script from "./SliderTanimla.vue?vue&type=script&lang=js&"
export * from "./SliderTanimla.vue?vue&type=script&lang=js&"
import style0 from "./SliderTanimla.vue?vue&type=style&index=0&id=2bcc4aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc4aee",
  null
  
)

export default component.exports